// extracted by mini-css-extract-plugin
export default {"treeview":"menu_treeview__Niay0","itemContainer":"menu_itemContainer__5UxQt","icon":"menu_icon__ZZe1B","iconContainer":"menu_iconContainer__FqSOl","dot":"menu_dot__mR+m6"};